<app-page-header [heading]="'Stock Value Report'" [icon]="'fa-google-wallet'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="row">
    <div class="col-lg-8"></div>
    <div class="col-lg-4">
      <div class="input-group ">
        <input (keydown)="keyDownFunction($event)" [(ngModel)]="search_text" class="form-control" id="typeahead-http"
               name="search_text"
               placeholder="Item / Product Code / HSN Code..." style="height:31px"
               type="text">
        <div class="input-group-append">
          <button class="input-group-text" style="height:31px;padding:7px">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="form-group col-lg-12 text-right">
      <label></label><br>
      <button (click)="ExportToExcel()" *ngIf="(stock_data | json) != '[]'" class="btn btn-info btn-sm"
              title="Export as XLSX">Export to XLSX&nbsp;<i class="fa fa-file-excel-o"></i></button>&nbsp;
      <app-report-pdf *ngIf="(stock_data | json) != '[]'" targetId="printReport" fileName="Stock_Value_Report.pdf" titleName="STOCK VALUE REPORT"></app-report-pdf>
      <br>
    </div>
    <div class="clearfix"></div>
    <div class=" col-12" id="printReport">
      <table #table class="table tbl table-hover table-striped table-bordered">
        <thead class="text-center">
        <tr>
          <th width="5%">Sl</th>
          <th class="text-left">Item</th>
          <th width="15%" class="text-right">Rate</th>
          <th width="10%" class="text-right">Quantity</th>
          <th width="15%" class="text-right">Amount</th>
        </tr>
        <tr *ngIf="(stock_data | json) == '[]'">
          <td class="text-center" colspan="7">No data to list</td>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let stock of stock_data;let i=index">
          <td class="text-center">{{ i + 1 }}</td>
          <td> {{ stock.TRADE_NAME }}</td>
          <td class="text-right">{{ stock.UNIT_PRICE }}</td>
          <td class="text-right">{{ stock.AVAILABLE_STOCK_QUANTITY }}</td>
          <td class="text-right">{{ stock.AMOUNT }}</td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <th colspan="4" class="text-right">Total Amount</th>
          <th class="text-right">{{ total_amount  | number : '1.2-2' }}</th>
        </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>
